import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "page-content"
}
const _hoisted_5 = { class: "width-wrap" }
const _hoisted_6 = { class: "estate-agent estate-agent--rating" }
const _hoisted_7 = { class: "estate-agent__content" }
const _hoisted_8 = { class: "estate-agent__name" }
const _hoisted_9 = { class: "estate-agent__info" }
const _hoisted_10 = { class: "estate-agent__company-position" }
const _hoisted_11 = { class: "estate-agent__photo-mobile" }
const _hoisted_12 = { class: "estate-agent__photo" }
const _hoisted_13 = {
  key: 0,
  class: "estate-agent__company-logo"
}
const _hoisted_14 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_15 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_16 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_17 = {
  key: 1,
  class: "form-body"
}
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "form-field is-rating" }
const _hoisted_20 = { class: "rating rating--stars-lg" }
const _hoisted_21 = { for: "frm-estateAgentReviewForm_review" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = {
  key: 0,
  class: "form-error"
}
const _hoisted_24 = { class: "form-footer" }
const _hoisted_25 = { class: "button button--primary" }
const _hoisted_26 = { class: "estate-agent__aside" }
const _hoisted_27 = { class: "estate-agent__photo" }
const _hoisted_28 = {
  key: 0,
  class: "estate-agent__company-logo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_star_rating = _resolveComponent("star-rating")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('EstateAgentReview.title')), 1)
      ])
    ]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.review && _ctx.review.fullName)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.review.fullName), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('EstateAgentReview.agent-position')), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_ResizableImage, {
                              url: _ctx.review.photoRelativeUrl,
                              placeholder: "img/no-photo-user.png",
                              width: 150,
                              height: 150,
                              alt: _ctx.review.fullName
                            }, null, 8, ["url", "alt"])
                          ]),
                          (_ctx.review.logoRelativeUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_component_ResizableImage, {
                                  classes: "estate-agency-logo",
                                  url: _ctx.review.logoRelativeUrl,
                                  width: 120,
                                  height: 67.5
                                }, null, 8, ["url"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("form", {
                  id: "estate-agent-review-form",
                  class: "form",
                  onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"])),
                  autocomplete: "off"
                }, [
                  (_ctx.showFormMessages)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_ctx.isSuccess)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('EstateAgentReview.success')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "flashmessage flash-danger"
                          }, _toDisplayString(error), 1))
                        }), 128)),
                        _createVNode(_component_router_link, {
                          to: "/",
                          class: "button button--primary",
                          tag: "button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('EstateAgentReview.homepage')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isSuccess && !_ctx.isNotFound)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_star_rating, {
                                rating: _ctx.v$.form.rating.$model,
                                "onUpdate:rating": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.rating.$model) = $event)),
                                increment: 0.5,
                                "max-rating": 5,
                                "star-size": 50,
                                "rounded-corners": true,
                                padding: 10,
                                "inactive-color": "#fff",
                                "active-color": "#12a55c",
                                "border-color": "#12a55c",
                                "border-width": 7,
                                "text-class": "rating__value"
                              }, null, 8, ["rating"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.review.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('EstateAgentReview.review')) + ":", 1),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.review.$model) = $event)),
                            type: "text",
                            id: "frm-estateAgentReviewForm_review",
                            name: "review",
                            placeholder: _ctx.$t('EstateAgentReview.review-placeholder'),
                            class: "form-control",
                            rows: "5"
                          }, null, 8, _hoisted_22), [
                            [
                              _vModelText,
                              _ctx.v$.form.review.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.form.review.$dirty && _ctx.v$.form.review.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.review.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.$t('EstateAgentReview.send')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 32)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_ResizableImage, {
                    url: _ctx.review.photoRelativeUrl,
                    placeholder: "img/no-photo-user.png",
                    width: 335,
                    height: 335,
                    alt: _ctx.review.fullName
                  }, null, 8, ["url", "alt"])
                ]),
                (_ctx.review.logoRelativeUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(_component_ResizableImage, {
                        classes: "estate-agency-logo",
                        url: _ctx.review.logoRelativeUrl,
                        width: 120,
                        height: 67.5
                      }, null, 8, ["url"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}